import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { validateFloatInput } from '@gk/gk-modules';
import { TranslateModule } from '@ngx-translate/core';
import { MCGRSettlementScopeFormGroup } from '../costs-section/costs-section-form.model';
import { MCGRCostsSectionComponent } from '../costs-section/costs-section.component';
import { MCGROtherSourceSettlementScopeFormArrayComponent } from '../other-source-settlement-scope-form-array/other-source-settlement-scope-form-array.component';
import { OtherSourceSettlementScope } from '../other-source-settlement-scope-form-array/other-source-settlement-scope-form-array.model';
import {
  MCGREstimatedWorksCostsFormGroup,
  MCGRNewRequestEstimatedWorksCostsControlName,
} from './works-estimated-costs-form.model';

@Component({
  selector: 'app-mcgr-work-estimated-costs',
  templateUrl: './works-estimated-costs.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    MCGRCostsSectionComponent,
    MCGROtherSourceSettlementScopeFormArrayComponent,
  ],
})
export class MCGRWorksEstimatedCostsComponent {
  controlName = MCGRNewRequestEstimatedWorksCostsControlName;
  @Input() formGroup: FormGroup<MCGREstimatedWorksCostsFormGroup>;
  @Input() submitted: boolean;
  @ViewChild(MCGROtherSourceSettlementScopeFormArrayComponent)
  mcgrOtherSourceSettlementScopeFormArrayComponent: MCGROtherSourceSettlementScopeFormArrayComponent;

  getMunicipalFundsFormGroup(): FormGroup<MCGRSettlementScopeFormGroup> {
    return this.formGroup.get(
      MCGRNewRequestEstimatedWorksCostsControlName.MunicipalFunds,
    ) as FormGroup<MCGRSettlementScopeFormGroup>;
  }

  getOwnFundsFormGroup(): FormGroup<MCGRSettlementScopeFormGroup> {
    return this.formGroup.get(
      MCGRNewRequestEstimatedWorksCostsControlName.OwnFunds,
    ) as FormGroup<MCGRSettlementScopeFormGroup>;
  }

  getStateBudgetFundsFormGroup(): FormGroup<MCGRSettlementScopeFormGroup> {
    return this.formGroup.get(
      MCGRNewRequestEstimatedWorksCostsControlName.StateBudgetFunds,
    ) as FormGroup<MCGRSettlementScopeFormGroup>;
  }

  getLocalGovernmentBudgetFundsFormGroup(): FormGroup<MCGRSettlementScopeFormGroup> {
    return this.formGroup.get(
      MCGRNewRequestEstimatedWorksCostsControlName.LocalGovernmentBudgetFunds,
    ) as FormGroup<MCGRSettlementScopeFormGroup>;
  }

  validateFloatInput(event: KeyboardEvent): void {
    if (!validateFloatInput(event.key)) {
      event.preventDefault();
    }
  }

  createFormArrayFromData(dataArray: OtherSourceSettlementScope[]): void {
    this.mcgrOtherSourceSettlementScopeFormArrayComponent.createFormArrayFromData(
      dataArray,
    );
  }

  isTotalAmountFormControlValid(): boolean {
    return this.getTotalAmountFormControl().valid;
  }

  getTotalAmountFormControl(): AbstractControl {
    return this.formGroup.get(
      MCGRNewRequestEstimatedWorksCostsControlName.TotalAmount,
    );
  }
}
